export default __webpack_public_path__ + "static/media/logoMarvel.74d959e2.png";